import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { REDIRECT_MS, SSO_ERROR_REDIRECTING_IN_5_SECONDS } from 'common/constants/sso';
import { ErrorComponent } from 'components';
import { useReadFragmentFromUrl } from 'hooks';

const SsoError = () => {
  const navigate = useNavigate();
  const { fragmentRef } = useReadFragmentFromUrl();

  useEffect(() => {
    // set timeout to redirect to login page after showing error
    const timer = setTimeout(() => {
      navigate('/');
    }, REDIRECT_MS);
    return () => clearTimeout(timer);
  }, [navigate, fragmentRef]);

  return (
    <ErrorComponent
      title="Error"
      subtitle=""
      body={SSO_ERROR_REDIRECTING_IN_5_SECONDS}
    />
  );
};

export default SsoError;
